import { MediaGroup } from "@buzzeasy/shared-frontend-utilities";
import { createApi } from "@reduxjs/toolkit/query/react";
import { ContentManagerConfig, ConversationSummary, EmailContent, EmailSummary } from "../../models/contentManager";
import { apiBaseQuery } from "../helpers";

const contentManagerApi = createApi({
  reducerPath: "contentManager",
  tagTypes: [],
  baseQuery: apiBaseQuery("/content"),
  endpoints: builder => ({
    getContentManagerConfig: builder.query<ContentManagerConfig, void>({
      query: () => "/tenant/settings",
    }),
    getConversationSummary: builder.query<ConversationSummary, { mediaGroup: MediaGroup; conversationId: string }>({
      query: ({ mediaGroup, conversationId }) => `/conversations/${conversationId}/summary?mediaGroup=${mediaGroup}`,
    }),
    getEmailSummary: builder.query<EmailSummary[], string>({
      query: conversationId => `/v2/messages/email/byconversationid/${conversationId}/summary`,
    }),
    getEmailContent: builder.query<EmailContent, string>({
      query: messageId => `/v2/messages/email/bymessageid?messageId=${messageId}`,
    }),
  }),
});

export const {
  useGetContentManagerConfigQuery,
  useLazyGetConversationSummaryQuery,
  useLazyGetEmailSummaryQuery,
  useLazyGetEmailContentQuery,
} = contentManagerApi;

export default contentManagerApi;
